import { ApiService } from './../../services/api.service';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SitesService {
    env = environment;
    options = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        })
    };

    constructor(private http: HttpClient, private apiService: ApiService,) { }

    getSites(): Observable<{}> {
        return this.http.get(this.env.apiPath + 'cms-sites', this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data.data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    getSite(siteId): Observable<{}> {
        return this.http.get(this.env.apiPath + 'cms-sites/' + siteId, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data.data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    postSite(site: any): Observable<{}> {
        return this.http.post(this.env.apiPath + 'cms-sites', site, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data.data;
                },
                    catchError(this.apiService.handleError)
                ));
    }

    putSite(site: any): Observable<{}> {
        return this.http.put(this.env.apiPath + 'cms-sites', site, this.apiService.getHttpOptions())
            .pipe(
                map((data: any) => {
                    return data.data;
                },
                    catchError(this.apiService.handleError)
                ));
    }
}
